import * as React from 'react'
import { ISalesFunnel } from '@user/store/salesFunnel'
import { useMemo } from 'react'
import { CardClosingRequirements } from '@sales-center/common'
import { ICloseRequirements } from '@user/store/opportunity'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

type ManageContainerHeaderProps = {
  salesFunnel?: ISalesFunnel
  requirements: CardClosingRequirements
}

export function ManageContainerHeader(props: ManageContainerHeaderProps) {
  const { salesFunnel, requirements } = props

  const requirementsList = useMemo(() => {
    const {
      paymentRequired,
      agreementRequired,
      agreementSignatureRequired,
      serviceScheduleRequired,
      freeEstimateScheduleRequired,
      paidEstimateScheduleRequired,
    } = requirements

    const list: ICloseRequirements['type'][] = ['Location']

    if (paymentRequired) list.push('Payment')
    if (agreementRequired) list.push('Agreements')
    if (agreementSignatureRequired) list.push('Agreement Signature')
    if (serviceScheduleRequired) list.push('Service Scheduled')
    if (freeEstimateScheduleRequired) list.push('Free Estimate')
    if (paidEstimateScheduleRequired) list.push('Paid Estimate')

    return list.join(', ')
  }, [requirements])
  const theme = useTheme()
  return (
    <>
      <Box display="flex" flexDirection="row" mb={0.6} ml={2}>
        <Typography variant="body2" color={theme.palette.text.primary}>
          Sales Funnel:&nbsp;
        </Typography>
        <Typography variant="body2" color={theme.palette.text.primary}>
          {salesFunnel?.name}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" mb={1} ml={2}>
        <Typography variant="body2" color={theme.palette.text.primary}>
          Required to Close Win:&nbsp;
        </Typography>
        <Typography variant="body2" color={theme.palette.text.primary}>
          {requirementsList}
        </Typography>
      </Box>
    </>
  )
}
